import { get, put, post } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

// Get Shedule (Team, Event, User) => Robots

export async function getSchedule({ team, event, user_id }) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/schedule?team_number=${team}&event=${event}&user_id=${user_id}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

// Add Schedule Row (Team, Event, Match, Robot, User)

export async function createScheduleRow(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = put({
      apiName: "igniteinsights",
      path: `/schedule`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log(e);
  }
}

// Edit Schedule Row (Team, Event, Match, Robot, User)

export async function editScheduleRow(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = post({
      apiName: "igniteinsights",
      path: `/schedule`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log(e);
  }
}
